export const NEWS_REACTION_EMOJIS = ["👍", "👎", "❤️", "🔥", "😂"] as const;

export type NewsReactionEmoji = (typeof NEWS_REACTION_EMOJIS)[number];

export const NEWS_REACTION_TARGET_TYPES = ["news", "comment"] as const;

export type NewsReactionTargetType = (typeof NEWS_REACTION_TARGET_TYPES)[number];

export interface NewsReactionTarget {
  targetType: NewsReactionTargetType;
  targetId: string;
}

export interface NewsReactionItem {
  targetType: NewsReactionTargetType;
  targetId: string;
  emoji: NewsReactionEmoji;
  count: number;
  isReactedByCurrentUser: boolean;
}

export function normalizeNewsReactionTargets(targets: NewsReactionTarget[]): NewsReactionTarget[] {
  const deduped = new Map<string, NewsReactionTarget>();

  for (const target of targets) {
    if (!target?.targetId) continue;
    deduped.set(`${target.targetType}:${target.targetId}`, {
      targetType: target.targetType,
      targetId: target.targetId,
    });
  }

  return [...deduped.values()].sort((left, right) => {
    const leftKey = `${left.targetType}:${left.targetId}`;
    const rightKey = `${right.targetType}:${right.targetId}`;
    return leftKey.localeCompare(rightKey);
  });
}

export function getNewsReactionTargetKey(target: NewsReactionTarget): string {
  return `${target.targetType}:${target.targetId}`;
}

export const isNewsReactionEmoji = (value: string): value is NewsReactionEmoji => {
  return (NEWS_REACTION_EMOJIS as readonly string[]).includes(value);
};
